export default function gallery() {
  let alpineComponent: any = null;

  let slidesContainer: HTMLElement | null = null;
  let thumbsContainer: HTMLElement | null = null;
  let currentSlide = 0;
  let totalSlides = 0;
  let autoplayInterval: number | null = null;

  let touchStartX: number = 0;
  let touchEndX: number = 0;
  let isDragging: boolean = false;
  let currentTranslate: number = 0;
  let startTranslate: number = 0;

  let thumbsMouseStartX: number = 0;
  let thumbsMouseEndX: number = 0;
  let isThumbsMouseDown: boolean = false;
  let hasThumbsMoved: boolean = false;
  let isThumbsDragging: boolean = false;
  let thumbsStartScrollLeft: number = 0;

  function updateSlidePosition() {
    if (!slidesContainer) {
      return;
    }
    const slideWidth = (100 / totalSlides).toFixed(4);
    currentTranslate = -(currentSlide * parseFloat(slideWidth));
    slidesContainer.style.transition = 'none';
    slidesContainer.style.transform = `translateX(${currentTranslate}%)`;
  }

  function updateSlidePositionAnimated() {
    if (!slidesContainer) {
      return;
    }
    const slideWidth = (100 / totalSlides).toFixed(4);
    currentTranslate = -(currentSlide * parseFloat(slideWidth));
    slidesContainer.style.transition = 'transform 0.3s ease-out';
    slidesContainer.style.transform = `translateX(${currentTranslate}%)`;
  }

  function updatePagination() {
    const pagination = document.querySelector('.custom-gallery-pagination');
    if (pagination) {
      pagination.textContent = `${currentSlide + 1} / ${totalSlides}`;
    }
  }

  function updateThumbnails() {
    const thumbnails = document.querySelectorAll('.custom-gallery-thumb');
    thumbnails.forEach((thumb, index) => {
      if (index === currentSlide) {
        thumb.classList.add('bg-white');
      } else {
        thumb.classList.remove('bg-white');
      }
    });
    const activeThumbnail = document.querySelector(`.custom-gallery-thumb:nth-child(${currentSlide + 1})`);
    if (activeThumbnail) {
      setTimeout(() => {
        activeThumbnail.scrollIntoView({ behavior: 'smooth', inline: 'center' });
      }, 0);
    }
  }

  function updateSections() {
    const sections = document.querySelectorAll('.slider-section');
    sections.forEach((section) => {
      const start = parseInt(section.getAttribute('data-start') || '0', 10);
      const end = parseInt(section.getAttribute('data-end') || '0', 10);

      if (currentSlide >= start && currentSlide < end) {
        section.classList.remove('opacity-60');
      } else {
        section.classList.add('opacity-60');
      }
    });
  }

  function goToSlide(index: number) {
    if (isThumbsDragging) {
      return;
    }

    let newIndex = index;
    if (newIndex < 0) {
      newIndex = totalSlides - 1;
    } else if (newIndex >= totalSlides) {
      newIndex = 0;
    }

    currentSlide = newIndex;
    updateSlidePositionAnimated();
    updatePagination();
    updateThumbnails();
    updateSections();
  }

  function nextSlide() {
    goToSlide((currentSlide + 1) % totalSlides);
  }

  function prevSlide() {
    goToSlide((currentSlide - 1 + totalSlides) % totalSlides);
  }

  function toggleAutoplay() {
    const progressBar = document.querySelector('.product-gallery-progress-bar');
    if (!progressBar) {
      return false;
    }
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
      (progressBar as HTMLElement).style.width = '0%';
    } else {
      let progress = 0;
      autoplayInterval = window.setInterval(() => {
        progress += 1;
        (progressBar as HTMLElement).style.width = `${progress}%`;
        if (progress >= 100) {
          progress = 0;
          nextSlide();
        }
      }, 50); // 5 seconds total (50ms * 100)
    }

    return !!autoplayInterval;
  }

  function handleDragStart(x: number) {
    touchStartX = x;
    touchEndX = x;
    startTranslate = currentTranslate;
    isDragging = true;

    if (slidesContainer) {
      slidesContainer.style.transition = 'none';
    }
  }

  function handleDragMove(x: number) {
    if (!isDragging) {
      return;
    }

    touchEndX = x;
    const diff = touchEndX - touchStartX;

    if (slidesContainer) {
      const movePercent = (diff / window.innerWidth) * (100 / totalSlides);
      currentTranslate = startTranslate + movePercent;
      slidesContainer.style.transform = `translateX(${currentTranslate}%)`;
    }
  }

  function handleDragEnd() {
    if (!isDragging) {
      return;
    }

    isDragging = false;

    if (slidesContainer) {
      slidesContainer.style.transition = 'transform 0.3s ease-out';
    }

    const diff = touchEndX - touchStartX;
    const percentThreshold = window.innerWidth * 0.2;
    const minPixelThreshold = 50;
    const threshold = Math.max(percentThreshold, minPixelThreshold);

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        prevSlide();
      } else {
        nextSlide();
      }
    } else {
      const slideProgress = (-currentTranslate * totalSlides) / 100;
      const nearestSlide = Math.round(slideProgress);
      const boundedSlide = Math.max(0, Math.min(nearestSlide, totalSlides - 1));
      goToSlide(boundedSlide);
    }
  }

  function handleKeyDown(e: KeyboardEvent) {
    if (alpineComponent.open) {
      if (e.key === 'ArrowLeft') {
        alpineComponent.prevSlide();
      } else if (e.key === 'ArrowRight') {
        alpineComponent.nextSlide();
      } else if (e.key === 'Escape') {
        alpineComponent.closeModal();
      }
    }
  }

  function handleThumbsMouseDown(e: MouseEvent) {
    e.preventDefault();

    isThumbsMouseDown = true;
    hasThumbsMoved = false;
    thumbsMouseStartX = e.clientX;

    if (thumbsContainer) {
      thumbsStartScrollLeft = thumbsContainer.scrollLeft;
      thumbsContainer.style.cursor = 'grabbing';
    }
  }

  function handleThumbsMouseMove(e: MouseEvent) {
    if (!isThumbsMouseDown) {
      return;
    }

    if (!hasThumbsMoved) {
      const moveDistance = Math.abs(e.clientX - thumbsMouseStartX);
      if (moveDistance > 5) {
        hasThumbsMoved = true;
        isThumbsDragging = true;
      }
    }

    if (!isThumbsDragging) {
      return;
    }

    thumbsMouseEndX = e.clientX;
    const diff = thumbsMouseStartX - thumbsMouseEndX;

    if (thumbsContainer) {
      thumbsContainer.scrollLeft = thumbsStartScrollLeft + diff;
    }
  }

  function handleThumbsMouseUp() {
    isThumbsMouseDown = false;

    if (isThumbsDragging) {
      hasThumbsMoved = false;

      if (thumbsContainer) {
        thumbsContainer.style.cursor = 'grab';
      }

      setTimeout(() => {
        isThumbsDragging = false;
      }, 0);
    }
  }

  function handleTouchStart(e: TouchEvent) {
    e.preventDefault();
    handleDragStart(e.changedTouches[0].screenX);
  }

  function handleTouchMove(e: TouchEvent) {
    e.preventDefault();
    handleDragMove(e.changedTouches[0].screenX);
  }

  function handleTouchEnd() {
    handleDragEnd();
  }

  function handleMouseDown(e: MouseEvent) {
    e.preventDefault();
    handleDragStart(e.clientX);
  }

  function handleMouseMove(e: MouseEvent) {
    handleDragMove(e.clientX);
  }

  function handleMouseUp() {
    handleDragEnd();
  }

  function init() {
    slidesContainer = document.querySelector('.custom-gallery-slides') as HTMLElement;
    thumbsContainer = document.querySelector('.custom-gallery-thumbs') as HTMLElement;
    const slides = document.querySelectorAll('.custom-gallery-slide');
    if (!slidesContainer || slides.length === 0) {
      return;
    }

    totalSlides = slides.length;

    slidesContainer.style.width = `${totalSlides * 100}%`;
    slidesContainer.style.transition = 'transform 0.3s ease-out';

    const slideWidth = (100 / totalSlides).toFixed(4);
    slides.forEach((slide) => {
      const slideElement = slide as HTMLElement;
      slideElement.style.width = `${slideWidth}%`;
      slideElement.style.flex = `0 0 ${slideWidth}%`;
    });

    thumbsContainer.style.cursor = 'grab';

    updateSlidePosition();

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mouseleave', handleMouseUp);
    document.addEventListener('mousemove', handleThumbsMouseMove);
    document.addEventListener('mouseup', handleThumbsMouseUp);
    document.addEventListener('mouseleave', handleThumbsMouseUp);
    slidesContainer.addEventListener('touchstart', handleTouchStart);
    slidesContainer.addEventListener('touchmove', handleTouchMove);
    slidesContainer.addEventListener('touchend', handleTouchEnd);
    slidesContainer.addEventListener('mousedown', handleMouseDown);
    thumbsContainer.addEventListener('mousedown', handleThumbsMouseDown);
  }

  return {
    currentSlide,
    totalSlides,
    open: false,
    showThumbs: true,
    fullScreen: false,
    autoplay: false,

    init() {
      alpineComponent = this;
      init();
    },

    openModal(selectedSlide: number) {
      goToSlide(selectedSlide);
      this.open = true;
      document.body.style.overflowY = 'hidden';
    },

    closeModal() {
      this.open = false;
      document.body.style.overflowY = 'initial';

      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
        this.autoplay = false;
      }
    },

    toggleThumbs() {
      this.showThumbs = !this.showThumbs;
    },

    toggleAutoplay() {
      this.autoplay = toggleAutoplay();
    },

    toggleFullScreen() {
      this.fullScreen = !this.fullScreen;
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    },

    moveToSection(index: number) {
      goToSlide(index);
    },

    nextSlide() {
      nextSlide();
    },

    prevSlide() {
      prevSlide();
    },

    goToSlide(index: number) {
      goToSlide(index);
    },
  };
}
